<div class="legend">
    <div *ngFor="let item of items" 
        (click)="navigate(item.link)" 
        [class.legend-active-link]="isActive(item.link)" 
        class="legend-item">
        {{item.name}}
    </div>
</div>
